import { type FC } from 'react'

import { ProductKeyFact } from './ProductKeyFact'
import { useProductPageKeyFacts } from './useProductPageKeyFacts'

export const ProductKeyFacts: FC = () => {
  const keyFacts = useProductPageKeyFacts()

  return (
    <div
      className="mb-5 rounded-s bg-light-primary-medium p-6 tablet:mb-12 desktop:mx-0"
      data-qa-id="product-key-facts-ho"
    >
      <ul className="flex flex-col gap-4 tablet:flex-row tablet:justify-between">
        {keyFacts.map((fact) => (
          <ProductKeyFact key={fact.title} keyFact={fact} />
        ))}
      </ul>
    </div>
  )
}
